import type { SVGProps } from 'react';

export default function RocketArrow(
  props: SVGProps<SVGSVGElement>,
): JSX.Element {
  return (
    <svg
      width="96"
      height="96"
      viewBox="0 0 96 96"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M37.5724 50.7197L26.6445 44.375C26.279 44.1628 26.1416 43.7028 26.3309 43.3249L30.5926 34.815C30.721 34.5585 30.977 34.3904 31.2635 34.3745L43.5626 33.6912C44.1355 33.6594 44.5546 34.2232 44.3591 34.7626L38.7262 50.3005C38.5562 50.7692 38.0036 50.97 37.5724 50.7197Z"
        fill="#C6B5F4"
      />
      <path
        d="M25.3781 44.4699L17.8546 58.442C17.4991 59.1022 16.5116 58.9599 16.3632 58.2249C15.1425 52.1796 11.7012 35.3484 10.4001 31.2C9.05525 26.912 5.42371 9.0731 4.32152 3.60229C4.19009 2.94994 4.86653 2.43327 5.46174 2.73087L32 16L63.9417 31.0529C64.6928 31.4068 64.474 32.5293 63.645 32.5753L30.8003 34.4L25.3781 44.4699Z"
        fill="#F6F3FE"
      />
      <path
        d="M30.8003 34.4L17.8546 58.442C17.4991 59.1022 16.5116 58.9599 16.3632 58.2249C15.1425 52.1796 11.7012 35.3484 10.4001 31.2C9.05525 26.912 5.42371 9.0731 4.32152 3.60229C4.19009 2.94994 4.86653 2.43327 5.46174 2.73087L32 16L63.9417 31.0529C64.6928 31.4068 64.474 32.5293 63.645 32.5753L30.8003 34.4ZM30.8003 34.4L22.4 26.8M25.3781 44.4699L37.8956 51.493C38.351 51.7485 38.9252 51.5062 39.06 51.0017L43.6 34"
        stroke="#291547"
        strokeWidth="3.6"
        strokeLinecap="round"
      />
      <path
        d="M44.1782 56.1812C44.1782 56.1812 49.5927 60.767 58.1782 70.1812C66.7637 79.5953 72.1782 84.1812 72.1782 84.1812"
        stroke="#291547"
        strokeWidth="3.6"
        strokeLinecap="round"
      />
      <path
        d="M36.4628 68.4649C36.4628 68.4649 42.3213 73.5232 45.758 77.7601C49.1947 81.997 55.0531 87.0553 55.0531 87.0553"
        stroke="#291547"
        strokeWidth="3.6"
        strokeLinecap="round"
      />
      <path
        d="M60.1718 52.1749C60.1718 52.1749 66.0303 57.2332 69.467 61.4701C72.9036 65.7069 78.7621 70.7652 78.7621 70.7652"
        stroke="#291547"
        strokeWidth="3.6"
        strokeLinecap="round"
      />
    </svg>
  );
}
